import https from "https";
import { getCurrentReporterVersion } from "@utils/common";
import axios from "axios";
import axiosRetry from "axios-retry";
import { keysToCamelCase, keysToSnakeCase } from "neetocist";
import { HEADERS_KEYS } from "./constants";
const isValidObject = (data) => data === Object(data) && !(data instanceof Buffer);
export const setAuthHeaders = ({ projectKey, apiKey, }) => {
    axios.defaults.headers = {
        ...axios.defaults.headers,
        [HEADERS_KEYS.projectKey]: projectKey,
        [HEADERS_KEYS.reporterVersion]: getCurrentReporterVersion(),
        [HEADERS_KEYS.apiKey]: apiKey !== null && apiKey !== void 0 ? apiKey : "",
        [HEADERS_KEYS.accept]: "application/json",
        [HEADERS_KEYS.contentType]: "application/json",
    };
};
export default function initializeAxios({ projectKey, baseURL, apiKey, }) {
    const httpsAgent = new https.Agent({
        keepAlive: false,
        timeout: 1.5 * 60 * 1000,
    });
    axios.defaults.baseURL =
        baseURL ||
            process.env.NEETO_PLAYDASH_API_BASE_URL ||
            "https://connect.neetoplaydash.com";
    axios.defaults.skipSnakeCaseConversion = false;
    axios.defaults.httpsAgent = httpsAgent;
    axios.defaults.timeout = 1.5 * 60 * 1000;
    setAuthHeaders({ projectKey, apiKey });
    axios.interceptors.request.use(config => {
        const data = config.data;
        if (isValidObject(data) && !config.skipSnakeCaseConversion) {
            config.data = keysToSnakeCase(data);
        }
        return config;
    });
    axios.interceptors.response.use(config => {
        const data = config.data;
        if (isValidObject(data)) {
            config.data = keysToCamelCase(data);
        }
        return config;
    });
    axiosRetry(axios, {
        retries: 3,
        retryDelay: retryCount => {
            const delay = Math.min(1000 * Math.pow(2, retryCount - 1), 10000);
            return delay;
        },
        retryCondition: error => {
            var _a;
            const status = (_a = error.status) === null || _a === void 0 ? void 0 : _a.toString();
            if (axiosRetry.isNetworkOrIdempotentRequestError(error)) {
                return true;
            }
            if (error.code === "ERR_SSL_DECRYPTION_FAILED_OR_BAD_RECORD_MAC" ||
                error.code === "EPROTO" ||
                (error.message && error.message.includes("decryption failed")) ||
                (error.message && error.message.includes("bad record mac"))) {
                return true;
            }
            if (error.code === "ETIMEDOUT" ||
                error.code === "ECONNRESET" ||
                error.code === "ECONNABORTED" ||
                error.code === "ENOTFOUND" ||
                error.code === "EAI_AGAIN" ||
                (error.message && error.message.toLowerCase().includes("timeout"))) {
                return true;
            }
            if (status) {
                return (status.startsWith("5") ||
                    status === "404" ||
                    status === "408" ||
                    status === "429");
            }
            return false;
        },
    });
}
export const directUploadAxios = axios.create({
    timeout: 0,
    httpsAgent: new https.Agent({ timeout: 0 }),
});
//# sourceMappingURL=axios.js.map